// frontend/src/styles/theme.js

export const theme = {
  colors: {
    // Cores da Marca (BusinessFlow)
    primary: "#3182ce",
    primaryHover: "#2b6cb0",
    primaryLight: "#ebf8ff",

    // Cores de Fundo e Superfície
    background: "#f7fafc",
    surface: "#ffffff",
    sidebar: "#1e293b", // Azul muito escuro/Slate

    // Texto
    text: "#1a202c",
    textSecondary: "#64748b",
    textMuted: "#a0aec0",

    // Status (Sucesso, Erro, Alerta)
    success: "#10b981",
    successLight: "#d1fae5",
    danger: "#ef4444",
    dangerLight: "#fee2e2",
    warning: "#f59e0b",
    warningLight: "#fef3c7",

    // Bordas e Linhas
    border: "#e2e8f0",
  },
  // Tamanhos seguros para o Mobile (Apple/Google Guidelines)
  sizes: {
    minTouchTarget: "44px",
    borderRadius: "8px",
  },
};
